import React, { Component } from "react";
import { withScope, captureException } from "@sentry/react";

import { getErrorCode } from "commons/src/helpers/errorHelpers";

import { logout } from "./DataOperations";
import { ErrorSupportNumber, ERROR } from "../helpers/ErrorHelpers";

const ERROR_MESSAGE = (
    <span>
        An unexpected error occurred. Please try to login again. If your query is urgent then please
        contact us on <ErrorSupportNumber /> or click on the live chat link.
    </span>
);
const FATAL = true;

function logError(error, errorCode, errorInfo = null) {
    withScope(scope => {
        scope.setTag("errorCode", errorCode);
        scope.setLevel("fatal");
        captureException(error, { extra: errorInfo });
    });
}

export function GoErrorLogger(WrappedComponent) {
    return class GoErrorLoggerComponent extends Component {
        state = {
            isError: false
        };

        isChromeScriptError = e => (e.message || "").includes("Script error");

        errorEventHandler = error => {
            if (!this.isChromeScriptError(error)) {
                logError(error, getErrorCode());
            }
        };

        componentDidMount() {
            window.addEventListener("error", this.errorEventHandler);
        }

        componentWillUnmount() {
            window.removeEventListener("error", this.errorEventHandler);
        }

        componentDidCatch(error, errorInfo) {
            const errorCode = getErrorCode();
            this.setState({ isError: true });
            logError(error, errorCode, errorInfo);
            logout({ message: ERROR_MESSAGE, severity: ERROR, errorCode, isFatal: FATAL });
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    };
}
